























import { Component, Inject } from "vue-property-decorator";
import WidgetBase from "../WidgetBase";
import Vue from "vue";
import App from "@ex/App.vue";

@Component({
  name: "ComponentHtmlWidget"
})
export default class ComponentHtmlWidget extends WidgetBase {
  @Inject({ from: "status", default: "" })
  declare public status: "mine" | "todo" | "done" | "wait" | "sent" | "fine" | "term" | "cc";

  @Inject({ from: "config", default: null })
  public config!: App.WebForm.ServiceOriginConfig;

  // 定义一个检查组件是否已注册的函数
  get isExist() {
    const temp = !!(Vue as any).options.components[this.widget.componentName];
    if (!temp) {
      console.log(temp, this.widget.componentName + ":自定义组件未全局注册");
    }
    return temp;
  }

  private getFormValues() {
    return (this.$refs[this.widget.componentName] as any).getFormValues?.(); //包含是否通过校验，表单数据，message
  }
}
